// extracted by mini-css-extract-plugin
export default {"boldText":"styles_boldText__Lg4xv"};